<template>
<div class="chapter">
<div class="inner_page">
<p class="center">To my wonderful cousins, the Miramichi MacDonalds, whose forebears emigrated to Cape Breton in 1824 from the West Highlands of Scotland. They have introduced me to New Scotland and shown me that the ties that bind families to their homeland, and to each other, are strong.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm-02.vue?41611631